import { render, staticRenderFns } from "./NewConfigurator.vue?vue&type=template&id=3464277b&lang=html&"
import script from "./NewConfigurator.vue?vue&type=script&lang=js&"
export * from "./NewConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports